import { render, staticRenderFns } from "./EpiLink.vue?vue&type=template&id=70162064"
import script from "./EpiLink.vue?vue&type=script&lang=js"
export * from "./EpiLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports